import { ApplicationName } from "../../../types/CPIPAppIntegration";
import {
  BaseRequestFailureAction,
  BaseRequestSuccessAction,
} from "../../../types";

export enum ActionTypes {
  CP_APP_EVAL_SKUS_REQUEST = "CP_APP_EVAL_SKUS_REQUEST",
  CP_APP_EVAL_SKUS_REQUEST_SUCCESS = "CP_APP_EVAL_SKUS_REQUEST_SUCCESS",
  CP_APP_EVAL_SKUS_REQUEST_FAILURE = "CP_APP_EVAL_SKUS_REQUEST_FAILURE",
  CP_APP_EVAL_SKUS_RESET = "CP_APP_EVAL_SKUS_RESET",
}

export interface AppEvaluationData {
  noEval: boolean;
  isPureEval: boolean;
}

export interface State {
  loading: boolean;
  error: string | null;
  data: AppEvaluationData | null;
}

export type RequestAction = {
  type: ActionTypes.CP_APP_EVAL_SKUS_REQUEST;
  app: ApplicationName;
};

export type RequestSuccessAction = BaseRequestSuccessAction<AppEvaluationData> & {
  data: AppEvaluationData;
};

export type RequestFailureAction = BaseRequestFailureAction<string> & {
  error: string;
};

export type ResetAction = {
  type: ActionTypes.CP_APP_EVAL_SKUS_RESET;
};

export type RequestActionCreator = (app: ApplicationName) => RequestAction;

export type RequestSuccessActionCreator = (
  data: AppEvaluationData
) => RequestSuccessAction;

export type RequestFailureActionCreator = (
  error: string
) => RequestFailureAction;

export type ResetActionCreator = () => ResetAction;
